import { render } from "./OnboardingGoal.vue?vue&type=template&id=432afeba"
import script from "./OnboardingGoal.vue?vue&type=script&lang=js"
export * from "./OnboardingGoal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__